import React from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../contexts/AuthContext";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
    const { t } = useTranslation();
    const { user, loading } = useAuth();
    const [searchParams] = useSearchParams();
    const redirect = searchParams.get("redirect") || "/";

    if (loading) return <div className="min-h-screen flex items-center justify-center bg-ink"><div className="w-8 h-8 border-2 border-gold border-t-transparent rounded-full animate-spin" /></div>;
    if (user) return <Navigate to={redirect} replace />;

    const handleGoogleLogin = () => {
        sessionStorage.setItem("post_login_redirect", redirect);
        const redirectUrl = window.location.origin + "/auth/callback";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-ink px-6 pt-20 grain" data-testid="login-page">
            <div className="max-w-md w-full">
                <div className="text-center mb-10">
                    <div className="inline-flex items-center gap-3 mb-6">
                        <div className="h-px w-10 bg-gold" />
                        <span className="text-gold text-xs tracking-[0.4em] uppercase" data-testid="login-section-label">{t("login.section_label")}</span>
                        <div className="h-px w-10 bg-gold" />
                    </div>
                    <h1 className="font-serif text-5xl text-white leading-tight" data-testid="login-title">
                        {t("login.title_1")}<br /><span className="italic text-gold">{t("login.title_2")}</span>
                    </h1>
                    <p className="text-gray-400 mt-4" data-testid="login-subtitle">{t("login.subtitle")}</p>
                </div>

                <div className="bg-ink-surface border border-white/10 rounded-sm p-8">
                    <button onClick={handleGoogleLogin}
                        className="w-full flex items-center justify-center gap-3 bg-white text-black font-medium px-6 py-4 rounded-sm hover:bg-gold transition-colors"
                        data-testid="google-login-btn">
                        <svg className="w-5 h-5" viewBox="0 0 24 24">
                            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                        </svg>
                        {t("login.continue_with_google")}
                    </button>
                    <p className="text-xs text-gray-500 text-center mt-6 leading-relaxed" data-testid="login-terms">
                        {t("login.terms_disclaimer")}
                    </p>
                </div>

                <div className="text-center mt-8">
                    <a href="/admin/login" className="text-xs text-gray-500 hover:text-gold tracking-widest uppercase" data-testid="admin-portal-link">
                        {t("login.restaurateur_link")}
                    </a>
                </div>
            </div>
        </div>
    );
}
